import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLanguage,
  setLanguage as setStoreLanguage,
} from "../../store/store";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

const LanguageOption = ({
  countryCode,
  text,
  onClick,
}: {
  countryCode: string;
  text: string;
  onClick?: () => void;
}) => (
  <div
    className="w-full flex flex-row items-center justify-center gap-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-2"
    onClick={onClick}
  >
    <ReactCountryFlag countryCode={countryCode} svg />

    <p className="hidden @[200px]:block">{text}</p>
  </div>
);

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const dispatch = useDispatch();

  const language = useSelector(selectLanguage);

  const changeLanguage = (value: "fr" | "en") => {
    i18n.changeLanguage(value);

    dispatch(setStoreLanguage(value));
  };

  const OPTIONS = [
    {
      countryCode: "US",
      text: "English",
      onClick: () => changeLanguage("en"),
    },
    {
      countryCode: "FR",
      text: "Français",
      onClick: () => changeLanguage("fr"),
    },
  ];

  return (
    <div className="@container w-full">
      <Popover>
        <PopoverTrigger className="w-full flex items-center justify-center gap-2 rounded border p-0.5 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800">
          {language === "en" ? (
            <LanguageOption countryCode="US" text="English" />
          ) : (
            <LanguageOption countryCode="FR" text="Français" />
          )}
        </PopoverTrigger>

        <PopoverContent side="top" align="center" className="w-full p-0">
          <div className="flex flex-col">
            {OPTIONS.map((option) => (
              <LanguageOption
                key={option.countryCode}
                countryCode={option.countryCode}
                text={option.text}
                onClick={option.onClick}
              />
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default LanguageSwitcher;
